export const TRAFFIC_MARK_PARAM = 'jpp_mark';

export function getTrafficLinkPath(link: string): string {
  const url = new URL(link);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function normalizeTrafficMark(value: string | null | undefined): string | null {
  const mark = value?.replace(/^ +| +$/g, '') ?? '';
  return /^[A-Za-z0-9]{1,64}$/.test(mark) ? mark : null;
}

export function readTrafficEntry(search: string): {
  hasParameter: boolean;
  mark: string | null;
  cleanSearch: string;
} {
  const params = new URLSearchParams(search);
  const values = params.getAll(TRAFFIC_MARK_PARAM);
  if (values.length === 0) return { hasParameter: false, mark: null, cleanSearch: search };
  params.delete(TRAFFIC_MARK_PARAM);
  const query = params.toString();
  return {
    hasParameter: true,
    mark: values.length === 1 ? normalizeTrafficMark(values[0]) : null,
    cleanSearch: query ? `?${query}` : '',
  };
}

export function buildOriginalTrafficLink(targetPath: string, origin: string): string {
  const target = targetPath.trim();
  if (!target || /^[\\/]{2}/.test(target)) throw new Error('INVALID_TARGET_PATH');
  const url = new URL(target, origin);
  if (!['http:', 'https:'].includes(url.protocol) || url.origin !== new URL(origin).origin) {
    throw new Error('INVALID_TARGET_PATH');
  }
  url.searchParams.delete(TRAFFIC_MARK_PARAM);
  const originalPath = getTrafficLinkPath(url.toString());
  if (originalPath.length > 2048 || /%(?![0-9a-f]{2})/i.test(originalPath)) {
    throw new Error('INVALID_TARGET_PATH');
  }
  return url.toString();
}

export function buildTrafficLink(targetPath: string, value: string, origin: string): string {
  const mark = normalizeTrafficMark(value);
  if (!mark) throw new Error('INVALID_TRAFFIC_MARK');
  const url = new URL(buildOriginalTrafficLink(targetPath, origin));
  url.searchParams.set(TRAFFIC_MARK_PARAM, mark);
  return url.toString();
}
